import { IconButton } from "@mui/material";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { styled as muiStyled } from '@mui/material/styles';

export const StyledHeroCardContainer = styled.div`
    width: 100%;
    height: 60vh;
    @media (min-width: 768px) {
        height: 75vh;
    }
`;

export const StyledHeroCard = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    &:hover {
        cursor: pointer;
    }
`;

export const StyledHeroCardImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
    
    /* Hide portrait image on landscape orientation */
    @media (orientation: landscape) {
        &[data-orientation="portrait"] {
            display: none;
        }
    }
    
    /* Hide landscape image on portrait orientation */
    @media (orientation: portrait) {
        &[data-orientation="landscape"] {
            display: none;
        }
    }
`;

export const StyledHeroCardTransition = styled.div`
    margin-top: -250px;
    height: 255px;
    width: 100%;
    background: linear-gradient(to bottom, rgba(30,31,35,0), rgba(30,31,35,1));
    background-size: 100%;
    background-repeat: no-repeat;
`;

export const StyledHeroCardContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 75%;
    font-family: Outfit;
    font-style: normal;
    font-weight: 400;
    line-height: 1.1;
    color: #FFFFFF;
    height: 100%;
    justify-content: center;
    padding-left: 10%;
    margin-top: 64px;
    font-size: 12px;
    position: relative;
    z-index: 1;
    
    @media (min-width: 768px) {
        padding-left: 5%;
        font-size: 22px;
        width: 50%;
    }

`;

export const StyledHeroCardDesc = styled.div`
    margin: 20px 0;
`;

export const StyledHeroCardTitle = styled.div`
    font-size: 22px;
    font-weight: 600;
    
    @media (min-width: 768px) {
        font-size: 32px;
}
`;

export const StyledCoursePlay = styled(IconButton)`
    .MuiSvgIcon-root{
        width: 64px;
        height: 64px;
        color: #FFFFFF;
        @media(min-width: 768px){
            width: 96px;
            height: 96px;
        }
    }
`;

export const StyledCarouselPrevIcon = muiStyled(ArrowBackIosNewIcon)`
        width: 30px;
        height: 45px;
        color: #FFFFFF;
        @media (min-width: 768px){
            width: 60px;
            height: 90px;
        }
`;

export const StyledCarouselNextIcon = muiStyled(ArrowForwardIosIcon)`
        width: 30px;
        height: 45px;
        color: #FFFFFF;
        @media (min-width: 768px){
            width: 60px;
            height: 90px;
        }
`;

export const StyledPlayButtonContainer = styled.div`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    color: #FFFFFF;
`;

export const StyledCarousel = styled(Carousel)`
    .carousel-control-prev {
        width: 5%;
        margin-top: 64px;
        .carousel-control-prev-icon{
            width: 48px;
            height: 48px;
        }
    }
    .carousel-control-next {
        width: 5%;
        margin-top: 64px;
        .carousel-control-next-icon{
            width: 48px;
            height: 48px;
        }
    }
    .carousel-indicators{
        bottom: 5%;
        @media(min-width: 768px){
            bottom: 10%;
        }
        button {
            width: 8px;
            height: 8px;
            background-color: darkgray;
            border-radius: 50%;
            border: none;
            margin-right: 14px;
            @media (min-width: 768px) {
                width: 16px;
                height: 16px;
            }
        }
        .active {
            background-color: #FFFFFF;        
        }
    }

`;